// Make dynamically-injected scripts compatible with strict CSP nonces.
//
// Two scenarios need handling:
//
// 1) jQuery's `dataType: "script"` AJAX responses (used by Rails UJS for
//    `format: :js` responses and `.js.erb` templates). The default converter
//    calls `jQuery.globalEval`, which inserts an inline `<script>` without a
//    nonce. Override the converter so the inserted script carries the nonce
//    from `<meta name="csp-nonce">`.
//
// 2) Turbo Drive re-creates `<script>` elements during navigation, but the
//    browser hides the nonce attribute value after the document is parsed, so
//    a copied script can end up with an empty nonce and be blocked by CSP.
//    Re-stamp nonce attributes on incoming scripts before Turbo renders them.

function csp_nonce_value() {
  var meta = document.querySelector('meta[name="csp-nonce"]');
  return meta ? meta.content : '';
}

(function($) {
  if (!$) return;

  $.ajaxSetup({
    converters: {
      'text script': function(text) {
        var nonce = csp_nonce_value();
        if (!nonce) {
          $.globalEval(text);
          return text;
        }
        var script = document.createElement('script');
        script.text = text;
        script.setAttribute('nonce', nonce);
        document.head.appendChild(script).parentNode.removeChild(script);
        return text;
      }
    }
  });
})(window.jQuery);

document.addEventListener('turbo:before-render', function(event) {
  // Turbo uses a CustomEvent; body is in event.detail.newBody.
  var newBody = event.detail && event.detail.newBody;
  if (!newBody) return;

  // Prefer the nonce in the incoming page; fall back to the current document's nonce.
  var incomingMeta = newBody.querySelector && newBody.querySelector('meta[name="csp-nonce"]');
  var nonce = (incomingMeta && incomingMeta.content) || csp_nonce_value();
  if (!nonce) return;

  var scripts = newBody.querySelectorAll('script');
  for (var i = 0; i < scripts.length; i++) {
    scripts[i].setAttribute('nonce', nonce);
  }
});
